import { render } from "./orgAdd.vue?vue&type=template&id=2506f939"
import script from "./orgAdd.vue?vue&type=script&lang=js"
export * from "./orgAdd.vue?vue&type=script&lang=js"

import "./orgAdd.vue?vue&type=style&index=0&id=2506f939&lang=less"

import exportComponent from "/var/jenkins_home/workspace/saas-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__